(() => {
  const desktopNavMinWidth = 1200;
  const initialDesktopClass = 'qoo-desktop-nav-initial';
  const headerSelector = '[data-site-header]';
  const compressedClass = 'site-header--compress';
  const desktopClass = 'site-header--qoo-desktop-nav';
  const tightClass = 'site-header--qoo-tight-nav';
  let frame;

  const syncHeaderNavigation = () => {
    const showDesktopNavigation = window.innerWidth >= desktopNavMinWidth;
    document.documentElement.classList.toggle(initialDesktopClass, showDesktopNavigation);

    const header = document.querySelector(headerSelector);
    if (!header) return;

    header.classList.toggle(compressedClass, !showDesktopNavigation);
    header.classList.toggle(desktopClass, showDesktopNavigation);
    header.classList.remove(tightClass);
    header.querySelectorAll('.qoo-nav-overflow').forEach((item) => item.classList.remove('qoo-nav-overflow'));

    if (!showDesktopNavigation) {
      header.style.removeProperty('--qoo-nav-left');
      header.style.removeProperty('--qoo-nav-right');
      return;
    }

    const logo = header.querySelector('[data-logo]');
    const icons = header.querySelector('[data-nav-icons]');
    const menu = header.querySelector('#NavStandard > .menu__items');
    if (!logo || !icons || !menu) return;

    const logoBounds = logo.getBoundingClientRect();
    const iconBounds = icons.getBoundingClientRect();
    const logoGap = 8;
    const iconGap = 50;

    header.style.setProperty('--qoo-nav-left', `${Math.ceil(logoBounds.right + logoGap)}px`);
    header.style.setProperty('--qoo-nav-right', `${Math.ceil(window.innerWidth - iconBounds.left + iconGap)}px`);

    const availableWidth = iconBounds.left - logoBounds.right - logoGap - iconGap;
    const menuItems = Array.from(menu.children);
    const menuGap = parseFloat(window.getComputedStyle(menu).columnGap) || 0;
    const requiredWidth = menuItems.reduce(
      (width, item) => width + item.getBoundingClientRect().width,
      0
    ) + menuGap * Math.max(menuItems.length - 1, 0);

    header.classList.toggle(tightClass, requiredWidth > availableWidth);
    const visibleItems = menuItems.filter((item) => window.getComputedStyle(item).display !== 'none');
    const fittedGap = parseFloat(window.getComputedStyle(menu).columnGap) || 0;
    let fittedWidth = visibleItems.reduce((width, item) => width + item.getBoundingClientRect().width, 0)
      + fittedGap * Math.max(visibleItems.length - 1, 0);
    while (fittedWidth > Math.max(0, availableWidth) && visibleItems.length) {
      const item = visibleItems.pop();
      fittedWidth -= item.getBoundingClientRect().width + (visibleItems.length ? fittedGap : 0);
      item.classList.add('qoo-nav-overflow');
    }
  };

  const scheduleSync = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(syncHeaderNavigation);
  };

  const init = () => {
    scheduleSync();
    document.addEventListener('theme:resize', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    window.addEventListener('resize', scheduleSync, {passive: true});
    window.addEventListener('pageshow', scheduleSync);
    document.fonts?.ready.then(scheduleSync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();
